// tslint:disable-next-line
const noop = () => {};
export default noop;
